import {Base} from "@/api/Base"

export class PayModeDelete extends Base {
    path = "payMode/delete"
}